<template>
  <div class="enr_con">
     <div class="imgurl"> <img src="../assets/images/22.png" alt=""> </div>
    <p class="navigation fl">您当前所在的位置：<router-link class="home" to="/home/index/">首页</router-link>&nbsp;>&nbsp;<a href="javascript:;" style="color:#666">招生报名</a></p>
    <div class="main">
      <left-comp></left-comp>
      <div class="enr_right">
        <ul class="enrtabs tab-hd">
          <li>
            <div class="title">完善个人信息</div>
            <personal-info ></personal-info>
          </li>
          <li>
            <div class="title">所填志愿</div>
            <encroll-application ></encroll-application>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import leftComp from "../components/leftComp";
import personalInfo from "../components/personalInfo";
import encrollApplication from "../components/encrollApplication";
export default {
  components: { leftComp, personalInfo, encrollApplication },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style scoped>
.enr_con > p {
  color: white;
}
.enr_right {
  border: none;
  box-shadow: none;
}
.enrtabs li .title {
  height: 50px;
  line-height: 50px;
  background: #f3f3f3;
  border: 1px solid #e0e0e0;
  color: #333;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/encrollabout.vue